import React from "react";
import classNames from "classnames";

import styles from "./Header.module.scss";

const BurgerIco = ({ className, isOpen, open, close }) => {
  return (
    <span
      className={classNames(
        styles.headerBurgerMenu,
        isOpen && styles.headerBurgerOpen,
        className
      )}
      onClick={() => {
        if (isOpen) {
          return close();
        } else {
          return open();
        }
      }}
    >
      <span className={styles.bar1}></span>
      <span className={styles.bar2}></span>
      <span className={styles.bar3}></span>
    </span>
  );
};

export default BurgerIco;
